import React from 'react';
import { Dropdown, DropdownOption } from '@ihsm/ui-shared';
import { useAppSelector, useActions } from 'state/store';

export const BenchmarkDropdown: React.FC = () => {
  const { setSelectedBenchmark } = useActions();
  const { selectedBenchmark, benchmarkList } = useAppSelector(
    (state) => state.benchmarkState
  );

  const contextChangeHandler = (benchmark: string) => {
    if (selectedBenchmark !== benchmark) {
      setSelectedBenchmark(benchmark);
    }
  };

  const options: DropdownOption[] = benchmarkList.map((bench) => ({
    displayText: bench,
    value: bench,
  }));

  return (
    <Dropdown
      labelText="Benchmark"
      value={selectedBenchmark}
      options={options}
      onChange={contextChangeHandler}
    />
  );
};
